import Table from "@/common/elements/Table";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "../InmateDetails/styles";
import Button from "@/common/elements/Button";
import { PlusOutlined } from "@ant-design/icons";
import { StyledFlex } from "@/common/styles";
import CustomModal from "../CustomModal";
import BailPaymentDetailForm from "./BailPaymentDetailForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidV4 } from "uuid";
import { Form, Popconfirm } from "antd";
import {
  setBookings,
  setDeleteAPis,
  setLastBookingsFromAPI,
} from "@/slices/bookingsSlice";
import {
  getBookingsByNumberUtil,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import dayjs from "dayjs";
import useDialog from "@/hooks/useDialog";
import _ from "lodash";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import notificationService from "@/util/notificationService";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const ChargesBailPaymentsDetails = ({
  bookingBailsData,
  bookingPayments,
  chargesData,
}) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const { showDialog } = useDialog();
  const dispatch = useDispatch();
  const [singleBookingPayments, setSingleBookingPayments] = useState(null);
  const [bookingBails, setBookingBails] = useState([]);
  const [isBailModal, setIsBailModal] = useState(false);
  const [isEditVisible, setisEditVisible] = useState(false);
  const [paymentsData, setPaymentsData] = useState([]);
  const [paymentForm] = Form.useForm();
  const [isAPICall, setisAPICall] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const fullSearch = useSelector(state => state.fullSearch);
  useEffect(() => {
    if (isNonEmptyVariable(bookingBailsData) && bookingBailsData?.length) {
      const optionsBookingBail = [];
      bookingBailsData?.forEach((element) => {
        if (
          !isNonEmptyVariable(element?.paid) ||
          (isNonEmptyVariable(element?.paid) && !element?.paid) ||
          (isNonEmptyVariable(element?.isPaymentBailAdd) && !isPaymentBailAdd)
        ) {
          optionsBookingBail.push({
            value: element?.bookingBailID || element?.bookingBailUuid,
            label: `$ ${element?.bailAmount}, Bail Type: ${
              isNonEmptyVariable(element?.bailTypeID)
                ? getRefListNameByID("BondType", element?.bailTypeID)
                : ""
            } ${
              isNonEmptyVariable(element?.courtNumber)
                ? "( " + element?.courtNumber + " )"
                : ""
            } `,
            data: element,
          });
        }
      });
      setBookingBails(() => optionsBookingBail);
    }

    if (isNonEmptyVariable(bookingPayments)) {
      let d = [];
      d = bookingPayments?.map((bp) => {
        return {
          ...bp,
          paymentType: getRefListNameByID("Payment_Type", bp?.paymentTypeID),
        };
      });

      setPaymentsData(() => d);
    }
  }, [bookingBailsData, bookingPayments]);

  const addPaymentModal = () => {
    setSingleBookingPayments(null);
    setIsBailModal(() => true);
    setisEditVisible(() => false);
  };

  const editPaymentModal = () => {
    setIsBailModal(() => true);
    setisEdit(true);
  };

  const selectRowsFn = (values) => {
    setSingleBookingPayments(values);
    setisEditVisible(() => true);
  };

  const cancelAction = () => {
    setSingleBookingPayments(null);
    setisEditVisible(() => false);
    setIsBailModal(() => false);
    setisEdit(false);
  };

  const onSaveClick = () => {
    paymentForm?.validateFields().then((v) => {
      if ((!isNonEmptyVariable(singleBookingPayments) ||
        !singleBookingPayments?.bookingBailPaymentBails?.length ) && !fullSearch
      ) {
        showDialog("info", {
          title: "Warning",
          content: "You must select atleast one bail to pay.",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (isNonEmptyVariable(v.paymentPaidDateTime)) {
        v.paymentPaidDateTime =
          v?.paymentPaidDateTime?.format("MM/DD/YYYY HH:mm");
      }

      const payload = {
        ...singleBookingPayments,
        ...v,
        bookingID: bookings?.bookingId,
        datePaid: v?.paymentPaidDateTime?.split(" ")?.[0],
        timePaid: v?.paymentPaidDateTime?.split(" ")?.[1],
        bailPaymentsUuid: uuidV4(),
        bioID: bookings?.bio?.[0]?.bioId || null,
        fullName: `${
          isNonEmptyVariable(bookings?.bio?.[0]?.fName)
            ? bookings?.bio?.[0]?.fName + " "
            : ""
        }${
          isNonEmptyVariable(bookings?.bio?.[0]?.mName)
            ? bookings?.bio?.[0]?.mName + " "
            : ""
        }${
          isNonEmptyVariable(bookings?.bio?.[0]?.lName)
            ? bookings?.bio?.[0]?.lName
            : ""
        }`,
      };

      let b = bookingBailsData;
      singleBookingPayments?.bookingBailPaymentBails?.forEach((bbpb) => {
        b = b?.map((bb) => {
          if (
            bb?.bookingBailID === bbpb?.bookingBailID ||
            bb?.bookingBailUuid === bbpb?.bookingBailUuid
          ) {
            return {
              ...bb,
              paid: true,
            };
          }
          return bb;
        });
      });

      let url = "";
      if (fullSearch) {
        const prevBookings = bookings; // <-- from useSelector
        const updated = {
          ...prevBookings,
          bookingBailPayments: [...(prevBookings?.bookingBailPayments || []), payload]
        };
        dispatch(setBookings(updated));
        cancelAction();
        return;
      }

      if (isEditVisible) {
        url = API_ENDPOINTS.bookingBailPayment_update;
      } else {
        url = API_ENDPOINTS.bookingBailPayment_create;
      }

      setisAPICall(() => true);
      api
        .post(url, payload)
        .then(async (res) => {
          if (res?.data?.statusCode === 200) {
            const data = await getBookingsByNumberUtil(bookings?.bookingNumber);
            dispatch(setLastBookingsFromAPI(data));
            dispatch(
              setBookings({
                ...data,
              })
            );
            if (isNonEmptyVariable(isEditVisible)) {
              notificationService.success(
                "Success!",
                "Bail Payment updated successfully"
              );
            } else {
              notificationService.success(
                "Success!",
                "Bail Payment created successfully"
              );
            }

            dispatch(
              setBookings({
                bookingBails: b,
              })
            );

            cancelAction();
          } else {
            if (isNonEmptyVariable(isEditVisible)) {
              notificationService.error(
                "Failed!",
                "Bail Payment updated failed"
              );
            } else {
              notificationService.error(
                "Failed!",
                "Bail Payment created failed"
              );
            }
          }
        })
        .catch(() => {
          if (isNonEmptyVariable(isEditVisible)) {
            notificationService.error("Failed!", "Bail Payment updated failed");
          } else {
            notificationService.error("Failed!", "Bail Payment created failed");
          }
        })
        .finally(() => {
          setisAPICall(() => false);
        });

      // if (isEditVisible) {
      //   updateBookingPayments = bookingPayments?.map((bp) => {
      //     if (
      //       bp?.bailPaymentsUuid === singleBookingPayments?.bailPaymentsUuid
      //     ) {
      //       return {
      //         ...bp,
      //         ...singleBookingPayments,
      //         ...v,
      //         datePaid: v?.paymentPaidDateTime?.[0],
      //         timePaid: v?.paymentPaidDateTime?.[1],
      //         bioID: bookings?.bio?.[0]?.bioId || null,
      //         fullName: `${
      //           bookings?.bio?.[0]?.fName ||
      //           "" + " " + bookings?.bio?.[0]?.mName ||
      //           "" + " " + bookings?.bio?.[0]?.lName ||
      //           ""
      //         }`,
      //       };
      //     }
      //     return bp;
      //   });
      // } else {
      //   const data = {
      //     ...singleBookingPayments,
      //     ...v,
      //     datePaid: v?.paymentPaidDateTime?.[0],
      //     timePaid: v?.paymentPaidDateTime?.[1],
      //     bailPaymentsUuid: uuidV4(),
      //     bioID: bookings?.bio?.[0]?.bioId || null,
      //     fullName: `${
      //       bookings?.bio?.[0]?.fName ||
      //       "" + " " + bookings?.bio?.[0]?.mName ||
      //       "" + " " + bookings?.bio?.[0]?.lName ||
      //       ""
      //     }`,
      //   };
      //   updateBookingPayments.push(data);
      // }

      // dispatch(
      //   setBookings({
      //     bookingBailPayments: updateBookingPayments,
      //     bookingBails: b,
      //   })
      // );
    });
  };

  const deletePayment = () => {
    let data = _.cloneDeep(paymentsData);
    data = data?.filter((d) => {
      return d?.bailPaymentsUuid !== singleBookingPayments?.bailPaymentsUuid;
    });

    dispatch(
      setBookings({
        bookingBailPayments: data,
      })
    );

    if (isNonEmptyVariable(singleBookingPayments?.bookingBailPaymentID)) {
      const url =
        API_ENDPOINTS.bookingBailPayments +
        "/id/" +
        singleBookingPayments?.bookingBailPaymentID;
      dispatch(setDeleteAPis(url));
    }

    cancelAction();
  };
  useEffect(() => {
    if (isEdit) {
      let showEdit = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (showEdit) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>List of Bail Payments</h6>
          <StyledFlex className="right" gap="10px">
            {
              <Button
                onClick={addPaymentModal}
                disabled={
                  !bookingsFieldsEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.ADD,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                <PlusOutlined /> Add
              </Button>
            }
            {
              <Button
                onClick={editPaymentModal}
                disabled={
                  !isEditVisible ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Details
              </Button>
            }
            <Popconfirm
              title="Delete the bail payment"
              description="Are you sure to delete this bail payment?"
              onConfirm={deletePayment}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{ marginLeft: "10px" }}
                color="primary"
                type="primary"
                disabled={
                  !isEditVisible ||
                  !bookingsFieldsEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.DELETE,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                DELETE
              </Button>
            </Popconfirm>
            <Button onClick={cancelAction} disabled={!isEditVisible}>
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={[
              { key: "id", text: "ID" },
              { key: "dateAdded", text: "Date Added" },
              { key: "timeAdded", text: "Time Added" },
              { key: "paymentAmount", text: "Amount" },
              { key: "paymentType", text: "Payment Type" },
              { key: "fullName", text: "Full Name" },
              { key: "bondedBy", text: "Bonded By" },
              { key: "bondNumber", text: "Bond Number" },
            ]}
            data={paymentsData}
            onRowClick={selectRowsFn}
            selected={singleBookingPayments === null}
          />
        )}
      </InmateDetailsTableContainer>

      {isBailModal && (
        <CustomModal
          header="Bail Payment Details"
          size="xl"
          show={isBailModal}
          onHide={cancelAction}
          onSaveClick={onSaveClick}
          isAPICall={isAPICall}
          isDisabled={isDisabled}
          onCloseClick={() => setisEdit(false)}
        >
          <BailPaymentDetailForm
            chargesData={chargesData}
            bookingBails={bookingBails}
            singleBookingPayments={singleBookingPayments}
            paymentForm={paymentForm}
            setSingleBookingPayments={setSingleBookingPayments}
          />
        </CustomModal>
      )}
    </>
  );
};
export default ChargesBailPaymentsDetails;
